export function isEnumLikeSchema(schema) {
    if (schema.enum) {
        return true;
    }
    if (schema.oneOf) {
        return schema.oneOf.every((optionSchema) => optionSchema.title !== undefined && (optionSchema.enum ?? optionSchema.const));
    }
    return false;
}
